// extracted by mini-css-extract-plugin
export default {"myOffersContainer":"MyOffers_myOffersContainer__RhrBR","titleContainer":"MyOffers_titleContainer__zD-2C"};